import { render, staticRenderFns } from "./dashboard_quick.vue?vue&type=template&id=2ade340c&"
import script from "./dashboard_quick.vue?vue&type=script&lang=js&"
export * from "./dashboard_quick.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_quick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports